// extracted by mini-css-extract-plugin
module.exports = {"List":"_3AWccLZpSr6PGQcKmhn5wa"};